/*
  Версия для слабовидящих: какие настройки бывают и как они хранятся.

  Решение владельца 02.10.2026 - вариант Б из макетов: кнопка включает сразу
  самый крупный шрифт чёрным по белому, размер и цвет на виду, остальное под
  «Ещё настройки». Набор - тот, что принят на российских сайтах (модуль
  «Версия для слабовидящих», сайты органов власти).

  Всё состояние - атрибуты на <html> (`data-low-vision`, `data-lv-*`), а вид по
  ним рисует `styles.lowvision.css`. Компоненты страницы о режиме не знают: так
  ни одна часть страницы не может «забыть» его поддержать.

  Выбор хранится в браузере человека. Это удобство, а не данные: хранилища
  может не быть (закрытый режим), и тогда страница просто открывается обычной.
*/

export const LOW_VISION_KEY = 'arbitr-low-vision'

// Значения каждой настройки, по порядку на экране. Первое у размера - самое
// мелкое из крупных: обычный размер даёт «Обычная версия».
export const CHOICES = {
  size: ['1', '2', '3'],
  theme: ['bw', 'wb', 'blue', 'brown', 'green'],
  images: ['on', 'off'],
  letters: ['1', '2', '3'],
  lines: ['1', '2', '3'],
  font: ['sans', 'serif'],
  speech: ['off', 'on'],
}

export const DEFAULTS = {
  size: '3',
  theme: 'bw',
  images: 'on',
  letters: '1',
  lines: '1',
  font: 'sans',
  speech: 'off',
}

const OFF = { on: false, ...DEFAULTS }

/** Сохранённый выбор; всё незнакомое заменяется значением по умолчанию. */
export function readSettings(storage) {
  let saved
  try {
    saved = JSON.parse(storage.getItem(LOW_VISION_KEY))
  } catch {
    return OFF
  }
  if (!saved || typeof saved !== 'object') return OFF
  const state = { on: saved.on === true }
  for (const [name, values] of Object.entries(CHOICES)) {
    state[name] = values.includes(saved[name]) ? saved[name] : DEFAULTS[name]
  }
  return state
}

export function writeSettings(storage, state) {
  try {
    storage.setItem(LOW_VISION_KEY, JSON.stringify(state))
  } catch {
    // Без хранилища выбор просто не запомнится: страница от этого не ломается,
    // а сказать человеку тут нечего - сделать с этим он ничего не может.
  }
}

/** Атрибуты <html> для состояния; у выключенного режима их нет вовсе. */
export function attributesFor(state) {
  if (!state.on) return {}
  const attributes = { 'data-low-vision': 'on' }
  for (const name of Object.keys(CHOICES)) {
    attributes[`data-lv-${name}`] = state[name]
  }
  return attributes
}

export const ATTRIBUTE_NAMES = ['data-low-vision', ...Object.keys(CHOICES).map((n) => `data-lv-${n}`)]
